import { postSaveDocument } from "../services/post-save-document";
import { notify } from "./_notify";

type SaveDocumentHandlerParams = {
  dispatch: any;
  setIsSavingDocument?: (value: boolean) => void;
  documentoId?: string;
  id: string;
  tipo: string;
  url: string;
};

export const saveDocumentWithNotify = ({
  dispatch,
  setIsSavingDocument,
  documentoId,
  id,
  tipo,
  url,
}: SaveDocumentHandlerParams) => {
  if (!documentoId) {
    notify(dispatch, {
      message: "Documento não encontrado para salvar.",
      title: "Erro",
      variant: "danger",
    });
    return Promise.resolve(false);
  }

  setIsSavingDocument?.(true);

  return postSaveDocument({ documentoId, id, tipo, url })
    .then(() => {
      notify(dispatch, {
        message: "Documento salvo com sucesso!",
        title: "Sucesso",
        variant: "success",
      });
      return true;
    })
    .catch((err: any) => {
      const isConflict = err?.response?.status === 409;
      notify(dispatch, {
        message: isConflict
          ? "Documento já foi salvo."
          : err?.message || "Erro ao salvar documento.",
        title: isConflict ? "Atenção" : "Erro",
        variant: isConflict ? "warning" : "danger",
      });
      return false;
    })
    .finally(() => setIsSavingDocument?.(false));
};
